import { all, fork } from "redux-saga/effects";

import authSaga from "./auth";
import systemSaga from "./system";
import entitySagas from "modules/entity/sagas";

export default function* rootSaga() {
	yield all([
		fork(authSaga),
		fork(systemSaga),
		fork(entitySagas),
	]);
}
